import { useFollowStore } from 'store';
import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { followFemale, unFollowFemale } from 'api';
import { queryKeys } from '../constants';

function useFollow() {
  const queryClient = useQueryClient();
  const { loadingFollow, addToFollowingList, removeToFollowingList } =
    useFollowStore();

  const followFemaleMutation = useMutation({
    mutationFn: (id: number) => {
      return followFemale(id);
    },
  });
  const unFollowFemaleMutation = useMutation({
    mutationFn: (id: number) => {
      return unFollowFemale(id);
    },
  });

  const handleFollow = useCallback(
    async (id: number, followed: boolean): Promise<boolean> => {
      try {
        addToFollowingList(id);
        if (followed) {
          await unFollowFemaleMutation.mutateAsync(id);
        } else {
          await followFemaleMutation.mutateAsync(id);
        }
        // ホームの「おすすめ」は refetchOnMount: false のため、非表示中でも読み直す
        queryClient.invalidateQueries({
          queryKey: [queryKeys.POST_RECOMMEND],
          refetchType: 'all',
        });
        return true;
      } catch (e) {
        console.log(e);
        return false;
      } finally {
        removeToFollowingList(id);
      }
    },
    [
      addToFollowingList,
      followFemaleMutation,
      queryClient,
      removeToFollowingList,
      unFollowFemaleMutation,
    ],
  );

  return {
    handleFollow,
    loadingFollow,
  };
}

export default useFollow;
